import React, {
  useEffect,
  useRef,
  useState,
} from 'react';
import {
  createDefaultConfig,
  defaultBackground,
  defaultOverlay,
} from './constants';
import LandingControls from './controls/LandingControls';
import DeviceStage from './preview/DeviceStage';
import './LandingPageSimulator.less';

function revokeBlobUrls(config) {
  if (config.backgroundImageUrl?.startsWith('blob:')) {
    URL.revokeObjectURL(config.backgroundImageUrl);
  }
  if (config.overlayImageUrl?.startsWith('blob:')) {
    URL.revokeObjectURL(config.overlayImageUrl);
  }
}

export default function LandingPageSimulator() {
  const [config, setConfig] = useState(createDefaultConfig);
  const configRef = useRef(config);
  configRef.current = config;

  useEffect(() => () => {
    revokeBlobUrls(configRef.current);
  }, []);

  const isBackgroundDefault = config.backgroundImageUrl === defaultBackground;
  const isOverlayDefault = config.overlayImageUrl === defaultOverlay;

  return (
    <div className="landing-page-simulator">
      <aside className="landing-page-simulator__sidebar">
        <LandingControls
          config={config}
          onChange={setConfig}
          isBackgroundDefault={isBackgroundDefault}
          isOverlayDefault={isOverlayDefault}
        />
      </aside>
      <main className="landing-page-simulator__preview">
        <DeviceStage config={config} />
      </main>
    </div>
  );
}
